<template>
  <ErrorPage code="500" overlay />
</template>

<script>
import ErrorPage from "@/components/Common/ErrorPage.vue";

// Server error. Registered globally as <ServerError> too, so a page can show it
// in place; it then covers the screen.
export default {
  name: "ServerError",
  components: { ErrorPage },
};
</script>
